import * as actions from './possibility-actions';
import * as mutations from './possibility-mutations';
import { state } from './possibility-state';

export const possibility = {
  state,
  mutations,
  actions,
};
